export default __webpack_public_path__ + "static/media/lcs-online-logo.49a6ecaa.png";